import { Errors, ErrorType } from '@equifinance/shared';
import isObject from 'lodash/isObject';
import { DocumentUsedEvidenceAccountantCertificate, DocumentUsedEvidenceAnnualAccount, WorkHistory } from '../../../contexts';

export function getApplicantWorkHistoryErrors(workHistory: WorkHistory, errors: Errors): ErrorType[] {
  const contractHistoryIds = (workHistory: WorkHistory) => workHistory?.contractHistories?.map((ch) => ch.id) ?? [];

  const getDocumentIds = (data: DocumentUsedEvidenceAccountantCertificate[] | DocumentUsedEvidenceAnnualAccount[]) => data?.map((doc: any) => doc.id) ?? [];
  const accountantCertificateIds = (workHistory: WorkHistory) => getDocumentIds(workHistory?.income?.documentUsedEvidenceAccountantCertificates?.data);
  const annualAccountIds = (workHistory: WorkHistory) => getDocumentIds(workHistory?.income?.documentUsedEvidenceAnnualAccounts?.data);

  return [
    ...(errors?.[workHistory?.id] ?? []),
    ...(errors?.[workHistory?.position?.id] ?? []),
    ...(errors?.[workHistory?.position?.companyAddress?.id] ?? []),
    ...(errors?.[workHistory?.accountantDetails?.id] ?? []),
    ...(errors?.[workHistory?.income?.id] ?? []),
    ...(errors?.[workHistory?.income?.documentUsedEvidenceSA302?.id] ?? []),
    ...accountantCertificateIds(workHistory).flatMap((id: string) => errors?.[id] ?? []),
    ...annualAccountIds(workHistory).flatMap((id: string) => errors?.[id] ?? []),
    ...(errors?.[workHistory?.employerDetails?.id] ?? []),
    ...(errors?.[workHistory?.employerDetails?.employerAddress?.id] ?? []),
    ...contractHistoryIds(workHistory).flatMap((id) => errors?.[id] ?? []),
  ];
}

export function collectIdFieldValues<T extends Object>(object: T): string[] {
  return Object.entries(object).reduce((prev, [key, value]) => {
    if (key === 'id') {
      return [...prev, value];
    }

    if (isObject(value)) {
      return [...prev, ...collectIdFieldValues(value)];
    }

    return prev;
  }, [] as string[]);
}
